import { render } from "./index.vue?vue&type=template&id=2f406ed5"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/featuresNav/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f406ed5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f406ed5', __exports__)) {
    api.reload('2f406ed5', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2f406ed5", () => {
    api.rerender('2f406ed5', render)
  })

}


export default __exports__